import React, { useEffect, useState } from "react";
import back from "../../../assets/back.svg";
import { NavLink, useNavigate } from "react-router-dom";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import ErrorMsg from "../../../components/form/errorMsg";
import { useDispatch } from "react-redux";
import {
  fieldForceAdminDetail,
  fieldForceAdminEditDetail,
  fieldForceAdminVerifyDetail,
} from "../../../redux/actions/fieldForceAction";
import ChangeSaved from "../../../components/popups/ChangeSaved";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const FieldForceAdminEdit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [adminData, setAdminData] = useState();
  const [verifyData, setVerifyData] = useState("");
  const [edited, setEdited] = useState(false);
  const [editedMsg, setEditedMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showErrorPopup1, setShowErrorPopup1] = useState(false);
  const [showErrorMsg1, setShowErrorMsg1] = useState("");
  const [showErrorPopup2, setShowErrorPopup2] = useState(false);
  const [showErrorMsg2, setShowErrorMsg2] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("");
  const [loding, setLoding] = useState(false);

  useEffect(() => {
    setLoding(true);
    dispatch(fieldForceAdminDetail(onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setLoding(false);
    console.log(data.data.data);
    setAdminData(data.data.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoding(false);
    console.log(err);
    // setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  useEffect(() => {
    if (verifyData !== "") {
      dispatch(
        fieldForceAdminVerifyDetail(verifyData, onVerifySuccess, onVerifyError)
      );
    }
  }, [verifyData]);

  const timeOutFnc1 = () => {
    setShowSuccessPopup(false);
  };

  const onVerifySuccess = (data) => {
    console.log(data);
    setAdminData(data.data.data);
    setShowSuccessPopup(true);
    const message = data.data.message;
    const str_message = message.charAt(0).toUpperCase() + message.slice(1);
    setShowSuccessMsg(str_message);
    setTimeout(timeOutFnc1, 2000);
  };

  const closeErrorPopup1 = () => {
    setShowErrorPopup1(false);
  };

  const onVerifyError = (err) => {
    console.log(err);
    setShowErrorPopup1(true);
    const str1 = err.data.message;
    const str_modify1 = str1.charAt(0).toUpperCase() + str1.slice(1);
    setShowErrorMsg1(str_modify1);
  };

  const initialValues = {
    employee_id: adminData?.employee_id,
  };

  const resetFunc = (setFieldValue) => {
    setFieldValue("employee_id", adminData?.employee_id);
  };

  const validationSchema = Yup.object().shape({
    employee_id: Yup.string().required("Required"),
  });

  const onSubmit = (values) => {
    console.log(values);
    dispatch(fieldForceAdminEditDetail(values, onEditSuccess, onEditError));
  };

  const onEditSuccess = (data) => {
    console.log(data);
    setEdited(true);
    const str = data.data.message;
    const edited_Msg = str.charAt(0).toUpperCase() + str.slice(1);
    setEditedMsg(edited_Msg);

    const timeOutFnc = () => {
      setEdited(false);
      navigate("/field-force/admin/view");
    };
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup2 = () => {
    setShowErrorPopup(false);
  };

  const onEditError = (err) => {
    console.log(err);
    setShowErrorPopup2(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg2(str_modify);
  };

  console.log(adminData);

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/field-force/admin/edit",
      breadcrumb: adminData?.code
        ? ` / field force / admin / ${adminData?.code} - edit`
        : " / field force / admin / edit",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });
  return (
    <>
      {loding ? (
        <LoadingSpinnerTable />
      ) : (
        <div className="products-page">
          <div className="products-main-div">
            <div className="mx-3">
              {breadcrumbs.map(({ match, breadcrumb }) => (
                <NavLink
                  key={match.pathname}
                  to={match.pathname}
                  className="header-route-page fw_400 cursor_pointer"
                >
                  <span className="fs_18">{breadcrumb}</span>
                </NavLink>
              ))}
            </div>
            <div className="products-main-list my-2 py-1">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize={true}
              >
                {({ setFieldValue, values }) => (
                  <Form className="">
                    <div className="search-container d-flex justify-content-between align-items-center">
                      <div
                        className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                        onClick={() => navigate(-1)}
                      >
                        <img src={back} alt="back_btn" />
                        <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                          BACK
                        </span>
                      </div>
                      <div className=" d-flex justify-content-between m-1 mb-2">
                        <AdminButton
                          background="#E7E5FF"
                          width="100px"
                          onClick={() => resetFunc(setFieldValue)}
                          type="button"
                        >
                          RESET
                        </AdminButton>
                        <AdminButton
                          background="#2AD3E7"
                          color="white"
                          width="100px"
                          type="submit"
                        >
                          <span className="m-2">SAVE</span>
                        </AdminButton>
                      </div>
                    </div>
                    <div className="form-width ms-4 ps-3 py-1 mt-4">
                      <div className="my-2">
                        <label className="w-100 color_747f9e fn_Nunito fs_14">
                          Company Employee ID
                        </label>
                        <div className="in-field d-flex align-items-center">
                          <Field name="employee_id">
                            {({ field, meta }) => (
                              <input
                                type="text"
                                {...field}
                                placeholder="Enter company employee ID"
                                className={`input borderLess`}
                                name="employee_id"
                              />
                            )}
                          </Field>

                          <button
                            type="button"
                            style={{
                              backgroundColor: "#7065E4",
                              borderRadius: "7px",
                              color: "#fff",
                              border: "none",
                            }}
                            onClick={() => {
                              setVerifyData(values.employee_id);
                            }}
                            className="py-1 px-4 fs_14"
                          >
                            VERIFY
                          </button>
                        </div>
                        <ErrorMsg name={"employee_id"} />
                      </div>
                      <div className="my-2 mt-3">
                        <label className="color_747f9e fs_14">User ID</label>
                        <p className="fs_14 color_262c3d">{adminData?.code}</p>
                      </div>
                      <div className="my-2">
                        <label className="color_747f9e fs_14">
                          Employee Name
                        </label>
                        <p className="fs_14 color_262c3d">{adminData?.name}</p>
                      </div>
                      <div className="my-2">
                        <label className="color_747f9e fs_14">
                          Phone Number
                        </label>
                        <p className="fs_14 color_262c3d">
                          +{adminData?.country_code}
                          <span className="ms-1">{adminData?.mobile}</span>
                        </p>
                      </div>
                      <div className="my-2">
                        <label className="color_747f9e fs_14">
                          Email Address
                        </label>
                        <p className="fs_14 color_262c3d">{adminData?.email}</p>
                      </div>
                      <div className="my-2">
                        <label className="color_747f9e fs_14">
                          Designation
                        </label>
                        <p className="fs_14 color_262c3d">
                          {adminData?.fieldForceDesignation?.name}
                        </p>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
              <ChangeSaved show={edited} title={editedMsg} />
              <ChangeSaved show={showSuccessPopup} title={showSuccessMsg} />
              <ErrorPopup
                show={showErrorPopup}
                title={showErrorMsg}
                handleClose={closeErrorPopup}
              />
              <ErrorPopup
                show={showErrorPopup1}
                title={showErrorMsg1}
                handleClose={closeErrorPopup1}
              />
              <ErrorPopup
                show={showErrorPopup2}
                title={showErrorMsg2}
                handleClose={closeErrorPopup2}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FieldForceAdminEdit;
